import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { EditingLockedContentContext } from 'Containers/EditingLockedContentContext';

const Echocardiography = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  const { openEditing } = React.useContext(EditingLockedContentContext);

  return (
    <HistorySection
      headerText={<FormattedMessage id={'imaging.echocardiography'} />}
      newButton={
        <DocumentCreationButton
          name="echocardiography"
          text={'imaging.newEchocardiography'}
          onClick={startEdit({}, 'echocardiography')}
          width={15}
          height={3}
          fontSize={12}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={4}>
              <FormattedMessage id={'imaging.lvef'} />
            </Item>
            <Item xs={4}>
              <FormattedMessage id={'imaging.fs'} />
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={4} id={'lvefPercent'}>
              {d.lvef ?? '-'}
            </Item>
            <Item xs={4} id={'fsPercent'}>
              {d.fs ?? '-'}
            </Item>
          </>
        )}
        makeDate
        makeControls
        historyRowControls={d => (
          <HistoryRowControls
            document={d}
            startEdit={
              d._lockedFor && d._source !== null ? doc => () => openEditing(doc, 'imaging.echocardiography') : startEdit
            }
          />
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'echocardiography'>[];
  startEdit: StartEdit;
}

export default Echocardiography;
